export const colorPicker = "editor/module/COLOR_PICKER";
export const hints = "editor/module/HINTS";
export const history = "editor/module/HISTORY";
export const layers = "editor/module/LAYERS";
export const map = "editor/module/MAP";
// export const properties = "editor/module/PROPERTIES";
export const tileSelector = "editor/module/TILE_SELECTOR";
